import { OpRadio } from 'new-components/DLS/OpRadio/OpRadio';
import { ComponentProps } from 'react';
import { OpForm } from '../../OpForm';
import { useOpFormContext } from '../../OpFormContext';
import { OpSkeleton } from '../../../OpSkeleton/OpSkeleton';

type OpFormRadioGroupProps = Pick<
  ComponentProps<typeof OpForm.Item>,
  'name' | 'rules' | 'label' | 'tooltip' | 'help' | 'initialValue'
> &
  Omit<ComponentProps<typeof OpRadio.Group>, 'name'> & {
    formItemClassName?: string;
    isLoading?: boolean;
  };

export const OpFormRadioGroup = ({
  // Form Item props
  formItemClassName,
  name,
  rules,
  label,
  tooltip,
  help,
  initialValue,

  // For skeleton loading state
  isLoading,

  ...props
}: OpFormRadioGroupProps) => {
  const { isDataLoading, isReadOnly } = useOpFormContext();

  return (
    <OpForm.Item
      className={formItemClassName}
      name={name}
      label={label}
      tooltip={tooltip}
      help={help}
      initialValue={initialValue}
      rules={rules}
    >
      {isDataLoading || isLoading ? (
        <OpSkeleton.Button active block={props.block} />
      ) : (
        <OpRadio.Group disabled={isReadOnly} {...props} />
      )}
    </OpForm.Item>
  );
};
